<lu-typeahead
	[formControl]="formControl | fromAbstractToFormControl"
	[options]="typeaheadOptions"
	[initialItems]="initialItems"
	[urlOptions]="urlOptions"
	[parentForm]="field.options.parentForm"
	(ngModelChange)="change($event)"
	[internalSelection]="internalSelection"
	(typeaheadReady)="typeaheadReady($event)"
	[attr.hasValue]="!!formControl?.value?.length"
	(internalSelectionChange)="internalSelectionChange($event)"
	(dropdownStateChange)="dropdownStateChange($event)">
</lu-typeahead>
